import { gql } from '@apollo/client';

export default gql`
  mutation NotifyLeadListUploaded($id: Int!) {
    notifyLeadListUploaded(id: $id)
  }
`;
